import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Founded and run by Ernest Kwiatek — qualified electrician with 10+ years on the tools.",
  "Local to Medway — fast response, fair pricing, real people on the phone.",
  "Every job certified, signed off and guaranteed. No corners cut.",
  "Tidy workmanship — we leave your home cleaner than we found it.",
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative bg-[#0F0F0F] py-28 lg:py-36 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Image side */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_medway-electric/artifacts/m8vv1axd_Screenshot_20260531_192512_Gallery.jpg"
              alt="Ernest Kwiatek on site"
              className="w-full h-full object-cover object-center grayscale-[20%] hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-transparent to-transparent" />
          </div>

          {/* Floating signature card */}
          <div className="absolute -bottom-6 -right-4 sm:right-6 bg-[#1A1A1A] border border-white/10 p-5 max-w-[220px]">
            <div className="text-[10px] tracking-[0.25em] text-[#1E90FF] uppercase mb-1">
              Owner
            </div>
            <div className="text-white font-medium" style={{ fontFamily: "Outfit" }}>
              Ernest Kwiatek
            </div>
            <div className="text-xs text-[#A0AAB2] mt-1">
              Optima Electrical Solutions Ltd
            </div>
          </div>
        </div>

        {/* Text side */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#1E90FF]">
              02 — About
            </span>
            <span className="h-px w-12 bg-[#1E90FF]/40" />
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-[1.05] tracking-tight"
            style={{ fontFamily: "Outfit" }}
          >
            A local electrician
            <br />
            <span className="text-[#A0AAB2] italic font-light">you can actually trust.</span>
          </h2>
          <p className="mt-8 text-[#A0AAB2] text-base lg:text-lg leading-relaxed max-w-xl">
            Optima Electrical Solutions was built on one principle: do every job
            properly, the first time. No oversold contracts, no faceless call
            centres — just an experienced electrician and a reliable team
            covering Medway and the surrounding areas of Kent.
          </p>

          <ul className="mt-10 space-y-4">
            {POINTS.map((p) => (
              <li key={p} className="flex gap-4 group">
                <CheckCircle2 className="w-5 h-5 text-[#1E90FF] mt-0.5 shrink-0" strokeWidth={1.5} />
                <span className="text-white/85 leading-relaxed group-hover:text-white transition-colors">{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-12 flex flex-wrap gap-6 items-center pt-8 border-t border-white/5">
            <div>
              <div className="text-3xl text-white font-semibold" style={{ fontFamily: "Outfit" }}>10+</div>
              <div className="text-xs text-[#A0AAB2] uppercase tracking-[0.2em] mt-1">Years on the tools</div>
            </div>
            <div className="h-10 w-px bg-white/10" />
            <div>
              <div className="text-3xl text-white font-semibold" style={{ fontFamily: "Outfit" }}>100%</div>
              <div className="text-xs text-[#A0AAB2] uppercase tracking-[0.2em] mt-1">Certified work</div>
            </div>
            <div className="h-10 w-px bg-white/10" />
            <div>
              <div className="text-3xl text-white font-semibold" style={{ fontFamily: "Outfit" }}>500+</div>
              <div className="text-xs text-[#A0AAB2] uppercase tracking-[0.2em] mt-1">Happy customers</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
